import { LockIcon } from 'lucide-react';

import type { GetCryptoExchangeRates200 } from 'api/customerApi';

export function CryptoExchangeRateDisplay({
  rateData,
  asset,
  toCurrency
}: {
  rateData: GetCryptoExchangeRates200;
  asset: string;
  toCurrency: string;
}) {
  const { quote_price: quotePrice, proceeds_after_fx_markup: proceeds } =
    rateData;

  return (
    <div className="flex flex-col">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row gap-2">
          <div className="flex font-light text-content-secondary">
            1 {asset}
          </div>
          =
          <div className="flex font-semibold">
            {quotePrice} {toCurrency}
          </div>
        </div>
        <div className="flex flex-col text-content-secondary">
          <div className="flex flex-row items-center gap-2">
            {' '}
            <LockIcon size={14} /> <p>Fixed rate</p>{' '}
          </div>
        </div>
      </div>
      <div className="flex flex-row gap-2">
        <div className="flex font-light text-content-secondary">
          Estimated amount:{' '}
        </div>
        <div className="flex font-semibold">{`${proceeds} ${toCurrency}`}</div>
      </div>
    </div>
  );
}
